import React, { Component } from 'react';

import { Tag,Row, Col,Menu,Pagination,message,Breadcrumb,Icon } from 'antd';
import { connect } from 'react-redux'
import {Link} from 'react-router-dom';
import Question from '../explain_detail_question/view';

import axios from 'axios';
import API from '../../../../API/api'
const EXPLAIN_TASK_STAGE_MAP = {
    '0':'pre_assign',
    '10':'img_explain',
    '20':'pre_img_explain_check',
    '30':'img_explain_check',
    '32':'img_explain_rework',
    '100':'pre_text_explain',
    '110':'text_explain',
    '120':'pre_text_explain_check',
    '130':'text_explain_check',
    '132':'text_explain_rework',
    '200':'text_explain_pass',
    '1003':'text_explain_onlineing',
    '1001':'text_explain_online_success',
    '1002':'text_explain_online_fail',
}
class MissionDetail extends Component{
    state = {
        name:'',
        chapter:'',
        clerk:'',
        total:1,
        listFilterNow:'all',
        page:1,
        pagesize:localStorage.getItem('questionlist_pagesize')||10,
        isVerify:false,
        task_id:'',
        list:[],
        stage:'',
    }
    listFilter =(val)=>{//筛选改变
        let {listFilterNow} = this.state
        if(listFilterNow===val.key) return
        this.setState({listFilterNow:val.key,page:1})
        setTimeout(()=>{
            this.getQuestionList()
        },0)
    }
    onPageChange =(val)=>{//翻页
        this.setState({page:val})
        setTimeout(()=>{
            this.getQuestionList()
            document.querySelector('.questionListScroll').scrollTop=0
        },0)
    }

    getQuestionList=()=>{
        let {listFilterNow,page,pagesize} = this.state

        let task_id = window.location.href.split('/').pop()
        let data = {
            task_id,
            question_stage:listFilterNow,
            page,
            pagesize,
        }

            axios.post(API.QUESTION_DETAIL_PAGE_LIST,data).then((res)=>{
                res = res.data
                if (res.code === 0) {
                    // this.setState({textClerkList:res.data.list})
                    let {page,pagesize,total,list} = res.data
                    this.setState({task_id,page,pagesize,total,list})

                }else{
                    message.error(res.message)
                }
            },()=>{message.error("网络错误！")})


    }

    refresh=()=>{
        this.getQuestionList()
    }
    componentDidMount(){
        this.getQuestionList()
        axios.post(API.EXPLAIN_TASK_INFO,{task_id:window.location.href.split('/').pop()}).then((res)=>{
            res = res.data
            if (res.code === 0) {
                this.setState({
                    name:res.data.name,
                    clerk:res.data.entry_user,
                    chapter:res.data.name_ext,
                    isVerify:this.state.isVerify,
                    stage:res.data.stage,
                })
            }else{
                message.error(res.message);
            }
        },(error)=>{
            message.error('网络错误！');
        });
    }
    render(){
        const {subject,role_qexplain} = this.props
        let current = EXPLAIN_TASK_STAGE_MAP[this.state.stage]
        return(
            <div>
                <Breadcrumb>
                    <Breadcrumb.Item style={{fontSize:20}}>
                        <Link to="/questionbox">题盒子</Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item style={{fontSize:20}}>
                        <span>任务详情</span>
                        <span>（&nbsp;{window.location.href.split('/').pop()}&nbsp;）</span>
                    </Breadcrumb.Item>
                </Breadcrumb>
                <Row style={{marginTop:15}}>
                    <Col span={20}>
                        <div style={{width:'100%',borderRadius:4,border:'solid 1px #999999',padding:'8px 15px'}}>
                            {this.state.name && <Tag color="#108ee9" style={{fontSize:14,margin:'3px 5px'}}>{this.state.name}</Tag>}
                            {this.state.chapter && <Tag color="#108ee9" style={{fontSize:14,margin:'3px 5px'}}>{this.state.chapter}</Tag>}
                            {/*{this.state.clerk && <Tag color="#108ee9" style={{fontSize:14,margin:'3px 5px'}}>录入员：{this.state.clerk}</Tag>}*/}
                        </div>
                    </Col>

                </Row>
                <Row style={{marginTop:15}}>
                    <div style={{fontSize:12}}>

                            { //编写解析阶段

                                current==='img_explain'&&
                                <Menu
                                    defaultSelectedKeys={['all']}
                                    onClick={(e)=>{this.listFilter(e)}}
                                    mode="horizontal"
                                    style={{backgroundColor:'#f5f6fa'}}
                                >
                                    <Menu.Item key={'all'}>全部</Menu.Item>
                                    <Menu.Item key={'pic_entry_finish'}>已完成</Menu.Item>
                                    <Menu.Item key={'pic_entry_not_finish'}>未完成</Menu.Item>
                                </Menu>


                            }
                            { //编写解析审核
                                current==='img_explain_check'&&
                                <Menu
                                    defaultSelectedKeys={['all']}
                                    onClick={(e)=>{this.listFilter(e)}}
                                    mode="horizontal"
                                    style={{backgroundColor:'#f5f6fa'}}
                                >
                                    <Menu.Item key={'all'}>全部</Menu.Item>
                                    <Menu.Item key={'pic_check_no'}>未审核</Menu.Item>
                                    <Menu.Item key={'pic_check_pass'}>审核通过</Menu.Item>
                                    <Menu.Item key={'pic_check_rework'}>返工</Menu.Item>
                                </Menu>
                            }
                            { //编写解析返工
                                current==='img_explain_rework'&&
                                <Menu
                                    defaultSelectedKeys={['all']}
                                    onClick={(e)=>{this.listFilter(e)}}
                                    mode="horizontal"
                                    style={{backgroundColor:'#f5f6fa'}}
                                >
                                    <Menu.Item key={'all'}>全部</Menu.Item>
                                    <Menu.Item key={'pic_rework_rework'}>返工</Menu.Item>
                                    <Menu.Item key={'pic_rework_checkpass'}>审核通过</Menu.Item>
                                    <Menu.Item key={'pic_rework_finish'}>完成</Menu.Item>
                                </Menu>
                            }


                            { //录解析阶段
                                current==='text_explain'&&
                                <Menu
                                    defaultSelectedKeys={['all']}
                                    onClick={(e)=>{this.listFilter(e)}}
                                    mode="horizontal"
                                    style={{backgroundColor:'#f5f6fa'}}
                                >
                                    <Menu.Item key={'all'}>全部</Menu.Item>
                                    <Menu.Item key={'text_entry_finish'}>已完成</Menu.Item>
                                    <Menu.Item key={'text_entry_not_finish'}>未完成</Menu.Item>
                                </Menu>
                            }
                            { //编写解析审核
                                current==='text_explain_check'&&
                                <Menu
                                    defaultSelectedKeys={['all']}
                                    onClick={(e)=>{this.listFilter(e)}}
                                    mode="horizontal"
                                    style={{backgroundColor:'#f5f6fa'}}
                                >
                                    <Menu.Item key={'all'}>全部</Menu.Item>
                                    <Menu.Item key={'text_check_no'}>未审核</Menu.Item>
                                    <Menu.Item key={'text_check_pass'}>审核通过</Menu.Item>
                                    <Menu.Item key={'text_check_rework'}>返工</Menu.Item>
                                </Menu>
                            }
                            { //编写解析返工
                                current==='text_explain_rework'&&
                                <Menu
                                    defaultSelectedKeys={['all']}
                                    onClick={(e)=>{this.listFilter(e)}}
                                    mode="horizontal"
                                    style={{backgroundColor:'#f5f6fa'}}
                                >
                                    <Menu.Item key={'all'}>全部</Menu.Item>
                                    <Menu.Item key={'text_rework_rework'}>返工</Menu.Item>
                                    <Menu.Item key={'text_rework_checkpass'}>审核通过</Menu.Item>
                                    <Menu.Item key={'text_rework_finish'}>完成</Menu.Item>
                                </Menu>
                            }

                    </div>
                </Row>
                <Row style={{height:"100%",position:'relative',zIndex:2}} className={'questionList explain-detail'}>
                    {
                        !!this.state.list.length ?
                            this.state.list.map((v,k)=>
                                <Question key = {k}
                                          role_qexplain={role_qexplain}
                                          stage={this.state.stage}
                                          subject={subject}
                                          taskId={this.state.task_id}
                                          page={this.state.page}
                                          data={v}
                                          refresh={()=>{this.refresh()}}
                                          k={k}
                                          tab={this.state.listFilterNow}
                                          />
                            )
                            :

                            <div style={{fontSize: "16px", height: "30px", marginBottom: "50px"}}>
                                <p style={{paddingTop: 15, paddingLeft: 50, color: 'green'}}>暂无题目</p>
                            </div>
                    }

                </Row>
                {
                    this.state.total>0 &&
                    <Row style={{marginTop:15,marginBottom:20,textAlign:'right'}}>
                        <Pagination current={this.state.page}
                                    total={this.state.total}
                                    onChange={ this.onPageChange }

                                    showSizeChanger
                                    showQuickJumper
                                    onShowSizeChange={ (current, pagesize)=>{this.setState({pagesize});this.onPageChange(1)} }
                                    pageSize={this.state.pagesize}
                        />

                    </Row>
                }
            </div>

        );
    }

}

const mapStateTopProps = (state) => {
    return {
        user:state.user,
        role_qexplain:state.user.role_qexplain,
        subject:state.user.subject,
    };
}
const mapDispatchToProps = dispatch => {
    return {
    }
};
export default connect(mapStateTopProps,mapDispatchToProps)(MissionDetail)




// WEBPACK FOOTER //
// ./src/entry_app/question_manage/question_explain/eplain_detail/view.js